import { createContext, useContext } from 'react';
import type { ISession } from '@/types/auth';

export type SessionStatus = 'signed-in' | 'signed-out' | 'in-progress' | 'error';

export interface SessionContextValue {
  status: SessionStatus;
  user?: ISession;
}

export const SessionContext = createContext<SessionContextValue>({ status: 'in-progress' });

export function useSession(): SessionContextValue {
  return useContext(SessionContext);
}
